module.exports = __webpack_public_path__ + "assets/img/3ac8-hm.svg";